<template>
    <form method="post" @submit.prevent="onSubmit">
        <div class="form-block--secondary">
            <div class="form__row">
                <div class="form__item">
                    <floor-plan-autocomplete :v="$v" @change="onChange" ref="floorPlan" name="form.floorPlanId"
                                             v-model="$v.form.floorPlanId.$model" length-type="w--m"/>
                    <div class="z1">
                        <button type="button" @click="createFloorPlan" iconic class="m--t-1"><span icon create></span>Založit
                            půdorys
                        </button>
                    </div>
                </div>
                <div class="form__item">
                    <type-autocomplete :v="$v" @change="onChange" name="form.typeId" ref="type"
                                       v-model="$v.form.typeId.$model" length-type="w--m"/>
                </div>
            </div>
        </div>

        <template v-if="floorPlan">
            <div class="overview m--t-1">
                <div class="overview__item overview__item--condensed">
                    <div class="overview__description">
                        <div class="overview__partials">
                            Plocha: <strong class="text--info">{{ floorPlan.floorArea }} ㎡</strong>
                        </div>
                        <div class="overview__partials">
                            Celková plocha: <strong class="text--info">{{ floorPlan.totalFloorArea }} ㎡</strong>
                        </div>
                        <div class="overview__partials" v-if="floorPlan.disposition">
                            Dispozice: <strong class="text--info">{{ floorPlan.disposition.title }}</strong>
                        </div>
                        <custom-button outline @click="updateFloorPlan(floorPlan.id)">
                            Upravit
                        </custom-button>
                    </div>
                </div>
            </div>
        </template>

        <div class="elementary-section__controls button-fix">
            <custom-button type="submit" small outline v-bind:class="{'no-updates': !formChanged}">
                Uložit
            </custom-button>
        </div>
    </form>
</template>

<script>
import {required} from 'vuelidate/lib/validators';
import FormCheckbox from 'domovio-core/src/components/Form/Input/FormCheckbox';
import FormInput from 'domovio-core/src/components/Form/Input/FormInput';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import TypeAutocomplete from '@/components/Autocomplete/TypeAutocomplete';
import FloorPlanAutocomplete from '@/components/Autocomplete/FloorPlanAutocomplete';
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import CreateFloorPlanDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/CreateFloorPlanDialog';
import UpdateFloorPlanDialog
    from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/UpdateFloorPlanDialog';

export default {
    name:       'PropertiesForm',
    components: {
        FloorPlanAutocomplete,
        TypeAutocomplete,
        CustomButton,
        FormInput,
        FormCheckbox,
    },
    data() {
        return {
            formChanged: false,
            floorPlan:   null,
            form:        {
                typeId:      null,
                floorPlanId: null,
            },
        }
    },
    validations: {
        form: {
            typeId:      {required},
            floorPlanId: {},
        },
    },
    watch:       {
        'form.floorPlanId': function () {
            this.fondFloorPlan();
        }
    },
    computed:    {
        unitData() {
            return this.$store.getters['projects/project/units/unit/unitData'];
        },
        dispositionId() {
            return this.$store.getters['projects/project/units/unit/dispositionId'];
        },
        typeId() {
            return this.$store.getters['projects/project/units/unit/typeId'];
        },
        floorPlanId() {
            return this.$store.getters['projects/project/units/unit/floorPlanId'];
        },
        floors() {
            return this.$store.getters['projects/project/floorPlan/floors'];
        }
    },
    mounted() {
        this.$refs.type.setSelectedId(this.typeId);
        this.$refs.floorPlan.setSelectedId(this.floorPlanId);
    },
    methods: {
        onSubmit() {
            this.$v.$touch();
            if (false === this.$v.$invalid) {
                const {typeId, floorPlanId} = this.form;
                this.$emit('o3-submit', {
                    typeId,
                    floorPlanId
                });
            }
        },
        onChange() {
            this.formChanged = true;
        },
        fondFloorPlan() {
            this.$store.getters['projects/project/floorPlan/loadFloorPlanById'](this.form.floorPlanId)
                .then((data) => this.floorPlan = data);
        },
        createFloorPlan() {
            this.$modal.show(CreateFloorPlanDialog, {}, defaultModalParameters());
        },
        updateFloorPlan(floorPlanId) {
            this.$modal.show(UpdateFloorPlanDialog, {floorPlanId}, defaultModalParameters());
        },
    }
}
</script>
